// Director data — keep separate so it's easy to update copy/photos later
export const directors = [
  {
    slug: "ikechukwu-iyke-chikezie",
    name: "Mr Ikechukwu Iyke Chikezie",
    title: "Founder & First Director",
    short:
      "Visionary founder building safe, supportive and empowering environments for vulnerable children.",
    photo:
      "/assets/directors/ikechukwu.png",
    initials: "IC",
    accent: "magenta",
    paragraphs: [
      "Mr Ikechukwu Iyke Chikezie is the visionary Founder and First Director of Dkarez Community Support CIC. His passion for supporting vulnerable children stems from a deep sense of compassion, responsibility, and commitment to community transformation.",
      "He established Dkarez Community Support CIC with a clear mission — to create safe, supportive, and empowering environments where vulnerable children can thrive regardless of their background or circumstances. Over the years, he has consistently supported families within the community by providing guidance, encouragement, and practical assistance to those facing challenges.",
      "His leadership is rooted in integrity, empathy, and long-term sustainability. He believes every child deserves dignity, stability, and the opportunity to reach their full potential.",
    ],
    vision:
      "To build Dkarez Community Support CIC into a trusted pillar of hope and structured support for vulnerable children and their families.",
    pillars: ["Integrity", "Empathy", "Sustainability"],
    contacts: {
      email: "dkarezcommunitys@gmail.com",
      phone: "+44 7400 455570",
    },
  },
  {
    slug: "promise-nkwachukwu-alioha",
    name: "Mr Promise Nkwachukwu Alioha",
    title: "Director",
    short:
      "Strategic thinker championing mentorship and life-skills for resilient young futures.",
    photo:
      "/assets/directors/promise.png",
    initials: "PA",
    accent: "wine",
    paragraphs: [
      "Mr Promise Nkwachukwu Alioha serves as a Director of Dkarez Community Support CIC, bringing dedication, strategic thinking, and a strong heart for social impact.",
      "His decision to join the organisation is driven by his genuine desire to empower vulnerable children through mentorship, structured support, and positive guidance. He believes that with early intervention and consistent encouragement, children can overcome barriers and build resilient futures.",
      "He has previously contributed to community-focused initiatives aimed at youth development, inclusion, and wellbeing. He is particularly passionate about building confidence, discipline, and life skills in young people.",
    ],
    vision:
      "To help strengthen Dkarez Community Support CIC's partnerships and services so that more vulnerable children can access meaningful and life-changing support.",
    pillars: ["Mentorship", "Inclusion", "Life Skills"],
    contacts: {
      email: "dkarezcommunitys@gmail.com",
      phone: "+44 7588 806587",
    },
  },
  {
    slug: "uchechukwu-godswill-alioha",
    name: "Mr Uchechukwu Godswill Alioha",
    title: "Director",
    short:
      "Thoughtful leader safeguarding fairness, equal opportunity and ethical governance.",
    photo:
      "/assets/directors/uchechukwu.png",
    initials: "UA",
    accent: "gold",
    paragraphs: [
      "Mr Uchechukwu Godswill Alioha joined Dkarez Community Support CIC with a firm belief that no child should be disadvantaged because of their circumstances.",
      "He brings thoughtful leadership, accountability, and a strong sense of fairness to the organisation. His passion lies in ensuring equal opportunities and safeguarding for vulnerable children, while promoting structured systems that deliver measurable impact.",
      "He understands the importance of ethical governance, collaboration with families, and professional service delivery. His contribution ensures that the organisation operates with transparency, integrity, and community trust.",
    ],
    vision:
      "To see Dkarez Community Support CIC become a respected and reliable source of support, advocacy, and empowerment for vulnerable children.",
    pillars: ["Governance", "Transparency", "Safeguarding"],
    contacts: {
      email: "dkarezcommunitys@gmail.com",
      phone: "+44 7838 972988",
    },
  },
  {
    slug: "chinonso-comfort-ikechukwu-chikezie",
    name: "Mrs Chinonso Comfort Ikechukwu-Chikezie",
    title: "Director",
    short:
      "Warm, family-centred advocate creating safe spaces where children feel heard and valued.",
    photo:
      "/assets/directors/chinonso.png",
    initials: "CI",
    accent: "magenta",
    paragraphs: [
      "Mrs Chinonso Comfort Ikechukwu-Chikezie serves as a Director of Dkarez Community Support CIC, bringing warmth, empathy, and strong family-centred values to the organisation.",
      "Her passion for vulnerable children is grounded in her belief that every child deserves love, stability, protection, and encouragement. She recognises that meaningful support extends beyond the child to include the family unit.",
      "She has actively supported families within the community through encouragement, practical assistance, and advocacy. She is especially passionate about safeguarding, emotional wellbeing, and creating safe spaces where children feel heard and valued.",
    ],
    vision:
      "To help nurture confident, secure, and empowered children who are strengthened by the support systems around them.",
    pillars: ["Family-First", "Safeguarding", "Emotional Wellbeing"],
    contacts: {
      email: "princessgolden1990@gmail.com",
      phone: "+447449910757",
    },
  },
];

export const findDirector = (slug) =>
  directors.find((d) => d.slug === slug) || null;
